import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Row, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { feeinvoicelist, feesummarylist } from "../../../services/admin";
import moment from "moment";
export const Invoice = () => {
  const { id, eid } = useParams();
  const [feedata, setFeeData] = useState([]);
  const [invno, setInvNo] = useState("");

  useEffect(() => {

    const temp = new FormData();
    temp.append("student_id", id);
    temp.append("payment_date", eid);
    feeinvoicelist(temp).then((res) => {
      if (res.status === true) {
        if (res.status === true && Array.isArray(res.data) && res.data.length > 0) {
          setFeeData(res.data);
          setInvNo(res.data[0]);
        } else {
          // handle empty or invalid data here
        }
      }
    });
  }, []);

  const handlePrint = () => {
    const invoiceInput = document.getElementById('invoice-number-input');
    const invoiceValue = invoiceInput ? invoiceInput.value : '';

    if (invoiceInput) {
      invoiceInput.style.display = 'none';
    }

    const invoiceValueElement = document.getElementById('invoice-number-value');
    if (invoiceValueElement) {
      invoiceValueElement.textContent = invoiceValue;
      invoiceValueElement.style.display = 'inline';
    }

    setTimeout(() => {
      window.print();
    }, 500);

    setTimeout(() => {
      if (invoiceInput) {
        invoiceInput.style.display = 'block';
      }
      if (invoiceValueElement) {
        invoiceValueElement.textContent = '';
      }
    }, 1000);
  };

  const handleShareOnWhatsApp = () => {
    const message = `
    ${feedata.academy_name}
      Hello ${feedata.full_name},
      Your Invoice Details:
      - Invoice No: ${invno}
      - Total Amount: ${feedata.payment_amount}
      - Admission Number: ${feedata.admission_number}
      - Payment Method: ${feedata.payment_method}
      - Date: ${moment(feedata.payment_date).format("DD-MM-YYYY")}
    `;

    const encodedMessage = encodeURIComponent(message);

    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

    window.open(whatsappUrl, "_blank");

    // const invoiceDiv = document.getElementById("invoice-container");

    // html2canvas(invoiceDiv).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");

    //   const whatsappUrl = `https://wa.me/?text=Check%20out%20this%20invoice:%20${encodeURIComponent(imgData)}`;

    //   window.open(whatsappUrl, "_blank");
    // });
  };
  const printRef = useRef();
  const cellStyle = {
    border: "1px solid #ccc",
    padding: "8px",
  };
  const handlePrinting = () => {
    // window.print();
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open('', '', 'height=700,width=900');
    printWindow.document.write(`
      <html>
        <head>
          <title>Fee Receipt</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            .receipt {
              width: 600px;
              margin: 0 auto;
              border: 1px solid #ccc;
              padding: 20px;
            }
              .avatar-upload .avatar-preBoopathi img{
              text-align: center;
              }
            h2, p {
              text-align: center;
              margin: 0;
              padding: 5px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              border: 1px solid #ccc;
              padding: 8px;
              text-align: left;
            }
            .total {
              font-weight: bold;
            }
            .right {
              text-align: right;
            }
            .signature {
              margin-top: 40px;
              text-align: right;
            }
            .note {
              margin-top: 30px;
              font-size: 12px;
            }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  const totalAmount = feedata.reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0);
  const amountInWords = numberToWords(Math.floor(totalAmount));

  function numberToWords(num) {
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
                 "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty",
                "Sixty", "Seventy", "Eighty", "Ninety"];

  const convertTens = (n) => {
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  };

  let result = "";

  if (num >= 1000) {
    const thousands = Math.floor(num / 1000);
    result += convertTens(thousands) + " Thousand ";
    num %= 1000;
  }

  if (num >= 100) {
    result += ones[Math.floor(num / 100)] + " Hundred ";
    num %= 100;
  }

  if (num > 0) {
    if (result !== "") result += "and ";
    result += convertTens(num);
  }

  return result.trim() + " Rupees Only";
}


  return (
    <Fragment>
      {/* <style>
        {`
        
          @media print {
        
            body * {
              visibility: hidden;
            }

           
            #invoice-container, #invoice-container * {
              visibility: visible;
            }

            #invoice-container {
              position: absolute;
              left: 0;
              top: 0;
            }
            #invoice-number-input {
              display: none;
            }
            #invoice-number-value {
              display: inline;
            }
          }
        `}
      </style> */}
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Fee Invoice</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Fee Module</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Fee Invoice
          </li>
        </ol>

      </div>
      <Row className="row-sm" id="invoice-container">
        <Col lg={12} md={12}>
          { /*<Card className="custom-card">
            <Card.Body >
              <div > 
              <div className="text-center p-4">
                <div className="avatar-upload">
                  <div className="avatar-preBoopathi">
                    <img
                      src={require("../../../assets/images/logo/logo.png")}
                      alt="Student"
                    />
                  </div>
                </div>
                <h2>Track Academy School</h2>
                <p className="px-sm-5">
                  No17/1, S R Complex, Karattur Road, Sathyamangalam, Opp SBI
                  Bank, Erode - 638402
                </p>
              </div>

              <hr className="mg-b-40" />
              <Row className="row-sm">
                <Col lg={6}>
                  <Row className="row-sm">
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Invoice No <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <input
                        type="text"
                        id="invoice-number-input"
                        className="form-control"
                        value={invno}
                        onChange={(e) => setInvNo(e.target.value)}
                      />
                      <h3 id="invoice-number-value" style={{ display: 'none' }} className="Teacher-detail-b"></h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Admission Number <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">{feedata.admission_number}</h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Name <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">{feedata.full_name}</h3>
                    </Col>

                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        E mail <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">
                        {feedata.parent_email}
                      </h3>
                    </Col>
                  </Row>
                </Col>
                <Col lg={6}>
                  <Row className="row-sm">
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Date <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">{moment(feedata.payment_date).format("DD-MM-YYYY")}</h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Academic Year <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">{feedata.aca_year}</h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Class <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">
                        {feedata.class_name}
                      </h3>
                    </Col>

                    <Col md={6} sm={6}>
                      <h3 className="Teacherdetail-a">
                        Section <span className="pull-end">:</span>
                      </h3>
                    </Col>
                    <Col md={6} sm={6}>
                      <h3 className="Teacher-detail-b">{feedata.section_name}</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="table-responsive mg-t-40">
                <table className="table card-table table-vcenter mb-0  border">
                  <thead>
                    <tr>
                      <th className="tx-center">Fee Type</th>
                      <th className="tx-center">Pending</th>
                      <th className="tx-center">Payment Method</th>
                      <th className="tx-center"> Fee Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="tx-center">{feedata.fee_type}{feedata.fee_month ? " (" + moment(feedata.fee_month, "YYYY-MM").format("MMMM YYYY") + ")" : ""}</td>
                      <td className="tx-center">{feedata.total_amount}.00</td>
                      <td className="tx-center">{feedata.payment_method}</td>
                      <td className="tx-right">{feedata.payment_amount}.00</td>
                    </tr>
                    <tr>
                      <td className="tx-center tx-uppercase tx-bold tx-inverse">
                        Total Paid
                      </td>
                      <td className="tx-right" colSpan="32">
                        <h4 className="tx-bold">{feedata.payment_amount}.00</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
             
            </Card.Body>
            <Card.Footer className=" text-end">
              <Button
                variant="secondary"
                type="button"
                className="btn ripple mb-1 me-2"
                onClick={handleShareOnWhatsApp}
              >
                <i className="fe fe-send me-1"></i> Send Invoice
              </Button>
              <Button
                variant="info"
                type="button"
                className="btn ripple  mb-1 me-2"
                onClick={handlePrint}
              >
                <i className="fe fe-printer me-1"></i> Print Invoice
              </Button>
            </Card.Footer>
          </Card>*/}
          <div>
            <button onClick={handlePrinting} style={{ margin: 20, padding: "10px 20px", background: "#007BFF", color: "#fff", border: "none", borderRadius: 5 }}>Print</button>

            <div ref={printRef} className="receipt">
              {/* Header with logo and school name */}
              <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "20px" }}>
                <img src={require("../../../assets/images/logo/logo.png")} alt="Logo" style={{ height: "80px" }} />
                <div>
                  {/* <h2 style={{ margin: 0 }}>dturn IT Solutions (P) Ltd</h2> */}
                  <h2 style={{ margin: 0 }}>Tracking Academy School</h2>
                  <p style={{ margin: 0 }}>
                    No17/1, S R Complex, Karattur Road, Sathyamangalam, Opp SBI Bank, Erode - 638402
                  </p>
                </div>
              </div>

              {/* Student Info */}
              <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td><b>Admission No:</b> {invno.admission_number}</td>
                    <td><b>Student Name:</b> {invno.full_name}</td>
                  </tr>
                  <tr>
                    <td><b>Class:</b> {invno.class_name} - {invno.section_name}</td>
                    <td><b>Roll No:</b>{invno.roll_number}</td>
                  </tr>
                  <tr>
                    <td><b>Receipt No:</b> {invno.inv_no}</td>
                    <td><b>Receipt Date:</b> {moment(invno.payment_date).format("DD-MM-YYYY")}</td>
                  </tr>
                </tbody>
              </table>

              {/* Fee Details */}
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f2f2f2" }}>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Particulars</th>
                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {feedata.map((fee, index) => (
                    <tr key={index}><td style={cellStyle}>{fee.fee_type}{fee.fee_month ? " (" + moment(fee.fee_month, "YYYY-MM").format("MMMM YYYY") + ")" : ""}</td><td style={cellStyle}>{parseFloat(fee.payment_amount).toFixed(2)}</td></tr>

                  ))}
                  <tr style={{ fontWeight: "bold" }}>
                    <td style={cellStyle}>Total</td>
                    <td style={cellStyle}> {feedata
                      .reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0)
                      .toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>

              <p style={{ marginTop: "20px" }}><b>In Words:</b> {amountInWords}</p>
              <p><b>Payment Mode:</b> Cash</p>
               <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "30px",
                    }}>
                      <p style={{ fontWeight: "bold", margin: 0 ,fontSize:"14px"}}>
                        Please note: Paid fees will not be refunded under any circumstances.
                      </p>

                      <b>Signature</b>
                    </div>

            </div>

          </div>
        </Col>
      </Row>
    </Fragment>
  )
}


